"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as L, jsx as n } from "react/jsx-runtime";
import * as s from "react";
import { BaseTouchable as V } from "./touchable.js";
import { buttonContainer as K, iconButtonTokens as M, minimumInteractiveArea as Y, disabled as q, overlayContainer as D, bleedLeft as F, bleedRight as G, bleedY as H, iconContainer as J, isLoading as Q, overlay as U, icon as W, iconSize as P, spinner as X } from "./icon-button.css-mistica.js";
import h from "classnames";
import Z from "./spinner.js";
import { useThemeVariant as _ } from "./theme-variant-context.js";
const N = /*#__PURE__*/ s.forwardRef((_param, z)=>{
    var { disabled: e, trackingEvent: r, role: f, dataAttributes: p, type: o = "neutral", backgroundType: b = "transparent", hasOverlay: S = !0, "aria-label": v, "aria-labelledby": c, small: d, Icon: R, bleedLeft: l, bleedRight: a, bleedY: I, showSpinner: g } = _param, m = _object_without_properties(_param, [
        "disabled",
        "trackingEvent",
        "role",
        "dataAttributes",
        "type",
        "backgroundType",
        "hasOverlay",
        "aria-label",
        "aria-labelledby",
        "small",
        "Icon",
        "bleedLeft",
        "bleedRight",
        "bleedY",
        "showSpinner"
    ]);
    const B = _(), [x, w] = s.useState(!1), t = g || x, [u, T] = s.useState(!!t);
    s.useEffect(()=>{
        t && !u && T(!0);
    }, [
        t,
        u
    ]);
    const i = d ? "small" : "default", A = B === "media" ? `${o}-media` : `${o}-${b}-${B}`, O = {
        disabled: e || t,
        ref: z,
        trackingEvent: r,
        role: f,
        "aria-label": v,
        "aria-labelledby": c,
        dataAttributes: _object_spread({
            "component-name": "IconButton"
        }, p),
        className: h(K[i], M[A], Y, {
            [q]: e,
            [D]: !e && !t,
            [F[i]]: l,
            [G[i]]: a,
            [H[i]]: I
        }),
        resetMargin: !l && !a && !I
    }, j = /* @__PURE__ */ L("div", {
        className: h(J[i], {
            [Q]: t
        }),
        children: [
            S && /* @__PURE__ */ n("div", {
                className: U
            }),
            /* @__PURE__ */ n("div", {
                "aria-hidden": t ? !0 : void 0,
                className: W,
                children: /* @__PURE__ */ n(R, {
                    size: P[i],
                    color: "currentColor"
                })
            }),
            /* @__PURE__ */ n("div", {
                "aria-hidden": t ? void 0 : !0,
                className: X,
                onTransitionEnd: ()=>{
                    t !== u && T(t);
                },
                children: u && /* @__PURE__ */ n(Z, {
                    size: P[i],
                    color: "currentColor",
                    delay: "0s"
                })
            })
        ]
    });
    if (m.onPress) {
        const k = m.onPress;
        m.onPress = (E)=>{
            const y = k(E);
            y && (w(!0), y.finally(()=>w(!1)));
        };
    }
    return /* @__PURE__ */ n(V, _object_spread_props(_object_spread({}, O, m), {
        maybe: !0,
        children: j
    }));
}), $ = /*#__PURE__*/ s.forwardRef((e, r)=>/* @__PURE__ */ n(N, _object_spread({
        ref: r
    }, e))), ie = /*#__PURE__*/ s.forwardRef((e, r)=>/* @__PURE__ */ n($, _object_spread({
        ref: r
    }, e))), C = /*#__PURE__*/ s.forwardRef((_param, v)=>{
    var { checked: e, defaultChecked: r, checkedProps: f, uncheckedProps: p, onChange: o, dataAttributes: b } = _param, S = _object_without_properties(_param, [
        "checked",
        "defaultChecked",
        "checkedProps",
        "uncheckedProps",
        "onChange",
        "dataAttributes"
    ]);
    const [c, d] = s.useState(!!r), R = ()=>{
        if (e === void 0) {
            const l = o == null ? void 0 : o(!c);
            if (l) return l.then(()=>d((a)=>!a)).catch(()=>{});
            d((a)=>!a);
        } else return o == null ? void 0 : o(!e);
    };
    return /* @__PURE__ */ n(N, _object_spread_props(_object_spread({
        ref: v
    }, S, (e !== null && e !== void 0 ? e : c) ? f : p), {
        dataAttributes: _object_spread({
            "component-name": "ToggleIconButton"
        }, b),
        onPress: R
    }));
}), ae = /*#__PURE__*/ s.forwardRef((e, r)=>/* @__PURE__ */ n(C, _object_spread({
        ref: r
    }, e)));
export { ie as IconButton, $ as InternalIconButton, C as InternalToggleIconButton, N as RawIconButton, ae as ToggleIconButton };
